import React from "react";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { AxiosService } from "../../services/axios/axiosService";

const safeStr = (v) => (typeof v === "string" ? v : v == null ? "" : String(v));

const ViewFeedbackModal = ({ open, onClose, interviewId, responses }) => {
  const list = Array.isArray(responses) ? responses : [];
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [rows, setRows] = React.useState([]);
const theme = useTheme();
  React.useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!open) return;
      if (!interviewId) {
        setRows([]);
        setError("");
        return;
      }
      try {
        setLoading(true);
        setError("");
        const res = await AxiosService.get(
          `/api/interview/feedback?interviewid=${interviewId}`,
        );
        const payload = res?.data ?? res;
        const arr = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.rows)
            ? payload.rows
            : [];
        if (!cancelled) setRows(arr);
      } catch (e) {
        if (!cancelled) setError(safeStr(e?.message) || "Failed to load feedback.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [open, interviewId]);

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body1" fontWeight={800}>
          View Feedback
        </Typography>
        <Button variant="outlined" color="secondary" size="small" onClick={onClose}>Close
          <CloseRoundedIcon fontSize="small" />
        </Button>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Typography variant="body2" color="text.secondary">
            Loading...
          </Typography>
        ) : error ? (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        ) : rows.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No feedback available.
          </Typography>
        ) : (
          <Stack spacing={1.25}>
            {rows.map((f, idx) => {
              const question = safeStr(f?.question).trim();
              const feedback = safeStr(f?.feedback).trim();
         
              return (
                <Box
                  key={f?.id ?? `${question}-${idx}`}
                  sx={(theme) => ({
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 2,
                    p: 1,
                    backgroundColor: theme.palette.background.paper,
                  })}
                >
                  <Stack direction="row" spacing={1.25} alignItems="flex-start">
                    <Box
                      sx={(theme) => ({
                        width: 26,
                        height: 26,
                        borderRadius: "999px",
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "rgba(59,130,246,0.20)"
                            : "rgba(59,130,246,0.12)",
                        color: theme.palette.primary.main,
                        fontWeight: 800,
                        fontSize: 12,
                      })}
                    >
                      {idx + 1}
                    </Box>
                    

                    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
                      <Typography variant="caption" sx={{ whiteSpace: "pre-wrap" }}>
                        {question || "-"}
                      </Typography>

                      {!!feedback && (
                        <Chip
                          label={feedback}
                          variant="outlined"
                          size="small"
                          sx={(theme) => ({
                            mt: 1,
                            height: 24,
                            borderRadius: 1.9,
                            fontSize: 11.5,
                            fontWeight: 500,
                            alignSelf: "flex-start",
                            borderColor: `${theme.palette.primary.main}66`,
                            color: theme.palette.primary.main,
                            backgroundColor: "transparent",
                            "& .MuiChip-label": { px: 1.1 },
                          })}
                        />
                      )}
                    </Box>
                  </Stack>
                </Box>
              );
            })}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewFeedbackModal;

